import Model from './Model'

export default class Maillist extends Model {
    resource() {
        return 'maillist'
    }

}
